import React, { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, applyTheme } from "@/context/ThemeContext";
import {
  CompConfigProvider,
  DEFAULT_COMP_CONFIG,
  parseCompConfigObject,
  applyCompConfigCssVars,
} from "@/context/CompConfigContext";
import ReactDOM from "react-dom/client"; // Import from 'react-dom/client'
import { store } from "./lib/redux/store";
import { Provider } from "react-redux";
import "./index.css";

import { BrowserRouter } from "react-router-dom";

import KeoBongVipPlugin from "./components/KeoBongVipPlugin";
import KbvTiLe from "./components/KbvTiLe";
import BangKeoKetQua from "./components/BangKeoKetQua";
import { BangXepHangPage } from "@/components/BangXepHang";
import LichThiDau from "./components/LichThiDau";
import KbvTiLeV2 from "./components/KbvTiLeV2";
import KbvTiLeV3 from "./components/KbvTiLeV3";
import KbvTiLeV4 from "./components/KbvTiLeV4";
import KbvTiLeV6 from "./components/KbvTiLeV6";
import KbvTiLeV5 from "./components/KbvTiLeV5";
import KbvTiLeV8 from "./components/KbvTiLeV8";
import KbvTiLeV10 from "./components/KbvTiLeV10";
import KbvTiLeV9 from "./components/KbvTiLeV9";
import KbvLiveScore from "./components/KbvLiveScore";
import KbvTiLeV13 from "./components/KbvTiLeV13";
import KbvTiLeV12 from "./components/KbvTiLeV12";
import KbvTiLeV14 from "./components/KbvTiLeV14";
import KbvLiveScoreV14 from "./components/KbvLiveScoreV14";
import KbvTiLeV15 from "./components/KbvTiLeV15";
import KbvTiLeV16 from "./components/KbvTiLeV16";
import KbvTiLeV17 from "./components/KbvTiLeV17";
import KbvTiLeV18 from "./components/KbvTiLeV18";
import KbvTiLeV19 from "./components/KbvTiLeV19";
import KbvTiLeV20 from "./components/KbvTiLeV20";
import KbvTiLeV21 from "./components/KbvTiLeV21";
import KbvTiLeV22 from "./components/KbvTiLeV22";
import KbvTiLeV23 from "./components/KbvTiLeV23";
import BangXepHangPageV2 from "./components/BangXepHangV2";
import BangXepHangPageV3 from "./components/BangXepHangV3";
import BangKeoKetQuaV2 from "./components/BangKeoKetQuaV2";
import BangKeoKetQuaV3 from "./components/BangKeoKetQuaV3";
import BangKeoKetQuaV4 from "./components/BangKeoKetQuaV4";
import AppAccessMessage from "./components/AppAccessMessage";
import { APP_KEY_ACCESS, APP_KEY_ACCESS_MESSAGES } from "@/constants/appKeyAccess";
import { resolveAppAccessWithDefaultKey } from "@/utils/appKeyAccess";
import { ENABLE_ACCESS_CHECK } from "@/config";
import { THEME_IDS, normalizeTheme } from "@/constants/themes";
import KbvHotMatches from "./components/HotMatches";
import KbvHotMatchesV2 from "./components/HotMatchesV2";
import LichThiDauV2 from "./components/LichiThiDauV2";
import LichThiDauV3 from "./components/LichThiDauV3";
import LichThiDauV4 from "./components/LichThiDauV4";
import LichThiDauFull from "./components/LichThiDauFull";
import LichThiDauFullSidebar from "./components/LichThiDauFullSidebar";
import BangKeoKetQuaFull from "./components/BangKeoKetQuaFull";
import BangKeoKetQuaSidebar from "./components/BangKeoKetQuaSidebar";
import LichThiDauByLeague from "./components/LichThiDauByLeague";
import LichThiDauByLeagueSidebar from "./components/LichThiDauByLeagueSidebar";
import BangXepHangByLeague from "./components/BangXepHangByLeague";
import BangXepHangByLeagueSidebar from "./components/BangXepHangByLeagueSidebar";
import LichThiDauByCountry from "./components/LichThiDauByCountry";
import LichThiDauByCountrySidebar from "./components/LichThiDauByCountrySidebar";
import BangXepHangByCountry from "./components/BangXepHangByCountry";
import BangXepHangByCountrySidebar from "./components/BangXepHangByCountrySidebar";
import BangXepHangFifaNam from "./components/BangXepHangFifaNam";
import BangXepHangFifaNu from "./components/BangXepHangFifaNu";
import BangKeoKetQuaByCountry from "./components/BangKeoKetQuaByCountry";
import BangKeoKetQuaByCountrySidebar from "./components/BangKeoKetQuaByCountrySidebar";
import KbvTiLeV24 from "./components/KbvTiLeV24";
import KbvTiLeV25 from "./components/KbvTiLeV25";
import KbvTiLeV26, {
  KbvTiLeV26KetQua,
  KbvTiLeV26KetQuaDark,
} from "./components/KbvTiLeV26";
import KbvTiLeV27 from "./components/KbvTiLeV27";
import KbvTiLeV28 from "./components/KbvTiLeV28";
import KbvTiLeV29 from "./components/KbvTiLeV29";
import KbvTiLeV30 from "./components/KbvTiLeV30";
import KbvTiLeV31 from "./components/KbvTiLeV31";
import KbvKetQuaLightV32 from "./components/KbvKetQuaLightV32";
import TopBanner from "./components/home/TopBanner";
import BottomBanner from "./components/home/BottomBanner";
import HotLeagueSideBar from "./components/home/HotLeagueSideBar";
import TopNhaiCaiSideBar from "./components/home/TopNhaiCaiSideBar";
import KbvFooter from "./components/home/Footer";
import HomeCenter from "./components/home/HomeCenter";
import HotInsightSideBar from "./components/home/HotInsightSideBar";
import HotDuDoanSideBar from "./components/home/HotDuDoanSideBar";
import HotNewsSideBar from "./components/home/HotNewsSideBar";
import HighlightVideoSideBar from "./components/home/HighlightVideoSideBar";
import HeaderDesktopMenu from "./components/home/HeaderDesktopMenu";

const DARK_THEME = THEME_IDS.electricGoldDarkSlate;

const isDarkComponentType = (type) =>
  typeof type === "string" && type.endsWith("dark");

const resolveRootTheme = (type, dataTheme) => {
  if (isDarkComponentType(type)) return DARK_THEME;
  return dataTheme;
};

const isReactBuild = process.env.REACT_APP_BUILD_TARGET === "react";
const shouldCheckAppAccess =
  String(ENABLE_ACCESS_CHECK ?? "true").trim().toLowerCase() !== "false";


if (isReactBuild) {
  renderApps("keobongvip-root");
}

const componentMap = {
  keobongvip: KeoBongVipPlugin,
  kbvbangkeo: KbvTiLe,
  kbvketqua: BangKeoKetQua,
  kbvbangxephang: BangXepHangPage,
  kbvlichthidau: LichThiDau,
  kbvbangkeov2: KbvTiLeV2,
  kbvbangkeov3: KbvTiLeV3,
  kbvbangkeov4: KbvTiLeV4,
  kbvbangkeov5: KbvTiLeV5,
  kbvbangkeov6: KbvTiLeV6,
  kbvbangkeov8: KbvTiLeV8,
  kbvbangkeov9: KbvTiLeV9,
  kbvbangkeov10: KbvTiLeV10,
  kbvlivescore: KbvLiveScore,
  kbvbangkeov11: KbvTiLeV12,
  kbvbangkeov12: KbvTiLeV13,
  kbvbangkeov14: KbvTiLeV14,
  kbvlivescorev14: KbvLiveScoreV14,
  kbvbangkeov15: KbvTiLeV15,
  kbvbangkeov16: KbvTiLeV16,
  kbvbangkeov17: KbvTiLeV17,
  kbvbangkeov18: KbvTiLeV18,
  kbvbangkeov19: KbvTiLeV19,
  kbvbangkeov20: KbvTiLeV20,
  kbvbangkeov21: KbvTiLeV21,
  kbvbangkeov22: KbvTiLeV22,
  kbvbangxephangv2: BangXepHangPageV2,
  kbvbangxephangv3: BangXepHangPageV3,
  kbvketquav2: BangKeoKetQuaV2,
  kbvketquav3: BangKeoKetQuaV3,
  kbvketquav4: BangKeoKetQuaV4,
  kbvhotmatch: KbvHotMatches,
  kbvhotmatchv2: KbvHotMatchesV2,
  kbvlichthidauv2: LichThiDauV2,
  kbvlichthidauv3: LichThiDauV3,
  kbvlichthidauv4: LichThiDauV4,
  kbvlichthidaufull: LichThiDauFull,
  kbvlichthidaufulldark: LichThiDauFull,
  kbvlichthidaufullsidebar: LichThiDauFullSidebar,
  kbvlichthidaufullsidebardark: LichThiDauFullSidebar,
  kbvketquafull: BangKeoKetQuaFull,
  kbvketquafulldark: BangKeoKetQuaFull,
  kbvketquasidebar: BangKeoKetQuaSidebar,
  kbvketquasidebardark: BangKeoKetQuaSidebar,
  kbvlichthidaubyleague: LichThiDauByLeague,
  kbvlichthidaubyleaguedark: LichThiDauByLeague,
  kbvlichthidaubyleaguesidebar: LichThiDauByLeagueSidebar,
  kbvlichthidaubyleaguesidebardark: LichThiDauByLeagueSidebar,
  kbvbangxephangbyleague: BangXepHangByLeague,
  kbvbangxephangbyleaguedark: BangXepHangByLeague,
  kbvbangxephangbyleaguesidebar: BangXepHangByLeagueSidebar,
  kbvbangxephangbyleaguesidebardark: BangXepHangByLeagueSidebar,
  kbvlichthidaubycountry: LichThiDauByCountry,
  kbvlichthidaubycountrydark: LichThiDauByCountry,
  kbvlichthidaubycountrysidebar: LichThiDauByCountrySidebar,
  kbvlichthidaubycountrysidebardark: LichThiDauByCountrySidebar,
  kbvbangxephangbycountry: BangXepHangByCountry,
  kbvbangxephangbycountrydark: BangXepHangByCountry,
  kbvbangxephangbycountrysidebar: BangXepHangByCountrySidebar,
  kbvbangxephangbycountrysidebardark: BangXepHangByCountrySidebar,
  kbvbangxephangfifanam: BangXepHangFifaNam,
  kbvbangxephangfifanamdark: BangXepHangFifaNam,
  kbvbangxephangfifanu: BangXepHangFifaNu,
  kbvbangxephangfifanudark: BangXepHangFifaNu,
  kbvketquabycountry: BangKeoKetQuaByCountry,
  kbvketquabycountrydark: BangKeoKetQuaByCountry,
  kbvketquabycountrysidebar: BangKeoKetQuaByCountrySidebar,
  kbvketquabycountrysidebardark: BangKeoKetQuaByCountrySidebar,
  kbvbangkeov23: KbvTiLeV23,
  kbvbangkeov24: KbvTiLeV24,
  kbvbangkeov25: KbvTiLeV25,
  kbvbangkeov26: KbvTiLeV26,
  kbvbangkeov26dark: KbvTiLeV26,
  kbvbangkeov26ketqua: KbvTiLeV26KetQua,
  kbvbangkeov26ketquadark: KbvTiLeV26KetQuaDark,
  kbvbangkeov27: KbvTiLeV27,
  kbvbangkeov28: KbvTiLeV28,
  kbvbangkeov29: KbvTiLeV29,
  kbvbangkeov30: KbvTiLeV30,
  kbvbangkeov31: KbvTiLeV31,
  kbvketqualightv32: KbvKetQuaLightV32,
  kbvtopbanner: TopBanner,
  kbvbottombanner: BottomBanner,
  kbvhotleaguesidebar: HotLeagueSideBar,
  kbvtopnhacaisidebar: TopNhaiCaiSideBar,
  kbvfooter: KbvFooter,
  kbvhomecenter: HomeCenter,
  kbvhotinsightsidebar: HotInsightSideBar,
  kbvhotdudoansidebar: HotDuDoanSideBar,
  kbvhotnewssidebar: HotNewsSideBar,
  kbvhighlightvideosidebar: HighlightVideoSideBar,
  kbvheaderdesktopmenu: HeaderDesktopMenu,
};

function parseDataConfig(rootElement) {
  const primaryPalette = (rootElement.getAttribute("data-primary") || "").trim();
  const extras = primaryPalette ? { primaryPalette } : {};
  const parsed = parseCompConfigObject(rootElement.getAttribute("data-config"));
  return {
    config: {
      ...DEFAULT_COMP_CONFIG,
      ...(parsed || {}),
      ...extras,
    },
    parsedConfig: parsed,
    hasDataConfig: !!parsed,
  };
}

function App({ league, country, type, config }) {
  const Component = componentMap[type] || (() => <div>Unknown type</div>);
  return <Component league={league} country={country} config={config} />;
}

function renderApps(className) {
  const rootElements = document.getElementsByClassName(className);

  Array.from(rootElements).forEach(async (rootElement) => {
    const type = rootElement.getAttribute("data-type");
    const league = rootElement.getAttribute("data-league");
    const country = rootElement.getAttribute("data-country");
    const theme = normalizeTheme(
      resolveRootTheme(type, rootElement.getAttribute("data-theme"))
    );
    applyTheme(theme, rootElement);
    const { config, parsedConfig, hasDataConfig } = parseDataConfig(rootElement);
    if (hasDataConfig) applyCompConfigCssVars(rootElement, parsedConfig);
    const root = ReactDOM.createRoot(rootElement);

    // if (shouldCheckAppAccess) {
    //   const dataAccessKey = (rootElement.getAttribute("data-access-key") || "").trim();
    //   let access;
    //   if (dataAccessKey) {
    //     access = await resolveAppAccessWithDefaultKey({
    //       type,
    //       activeStatus: APP_KEY_ACCESS.activeStatus,
    //       messages: APP_KEY_ACCESS_MESSAGES,
    //       key: dataAccessKey,
    //     });
    //     if (!access.allowed) {
    //       access = await resolveAppAccessWithDefaultKey({
    //         type,
    //         activeStatus: APP_KEY_ACCESS.activeStatus,
    //         messages: APP_KEY_ACCESS_MESSAGES,
    //       });
    //     }
    //   } else {
    //     access = await resolveAppAccessWithDefaultKey({
    //       type,
    //       activeStatus: APP_KEY_ACCESS.activeStatus,
    //       messages: APP_KEY_ACCESS_MESSAGES,
    //     });
    //   }

    //   if (!access.allowed) {
    //     root.render(<AppAccessMessage message={access.message} />);
    //     return;
    //   }
    // }

    root.render(
      <Suspense fallback={<p>Loading...</p>}>
        <Provider store={store}>
          <ThemeProvider initialTheme={theme} themeRoot={rootElement}>
            <CompConfigProvider
              config={config}
              hasDataConfig={hasDataConfig}
              parsedConfig={parsedConfig}
            >
              <BrowserRouter>
                <HelmetProvider>
                  <App type={type} league={league} country={country} config={config} />
                </HelmetProvider>
              </BrowserRouter>
            </CompConfigProvider>
          </ThemeProvider>
        </Provider>
      </Suspense>
    );
  });
}
